<template>
  <el-dialog
    :visible.sync="showDialog"
    :before-close="handleClose"
    :width="modalWidth"
    top="10vh"
    custom-class="custom-scrollable"
  >
    <div class="font-normal my-4" v-if="toShow == 'depositAmount'">
      <div class="text-black mb-12 font-bold flex justify-center text-xl">
        Deposit
      </div>
      <span class="font-semibold flex justify-center text-sm">
        {{ pendingDepositDetails ? 'Edit' : 'Enter' }} Deposit Amount</span
      >

      <div class="mx-4">
        <el-form
          label-position="top"
          :model="depositAmountForm"
          ref="depositAmountForm"
          :rules="rules"
          label-width="80px"
          size="normal"
        >
          <el-form-item prop="amount" class="mb-4">
            <el-input
              type="amount"
              class="md:text-xl text-sm"
              v-model="depositAmountForm.amount"
              name="amount"
              placeholder="$0.00"
            >
            </el-input>
          </el-form-item>
          <el-form-item class="mt-8 mb-6">
            <o-button
              v-if="!pendingDepositDetails"
              :disabled="depositAmountForm.amount.length <= 0"
              @click="validateDepositAmount('depositAmountForm')"
              v-loading="isLoading"
              :class="
                isLoading ? ' cursor-not-allowed opacity-30' : ' cursor-pointer'
              "
              >Next
            </o-button>
            <div
              class="md:flex-row flex-col flex text-white justify-between items-center w-full"
              v-if="pendingDepositDetails"
            >
              <div
                @click="handleClose"
                class="md:w-44 w-36 h-12 bg-white cursor-pointer font-semibold hover:opacity-80 flex mb-3 md:mb-0 text-primary items-center justify-center border border-primary rounded-full md:px-14"
              >
                Done
              </div>
              <div
                @click="validateDepositAmount('depositAmountForm')"
                v-loading="isLoading"
                :class="
                  isLoading
                    ? ' cursor-not-allowed opacity-30'
                    : ' cursor-pointer'
                "
                class="h-12 md:w-44 w-36 bg-primary cursor-pointer hover:opacity-80 font-semibold flex items-center justify-center rounded-3xl md:px-10 mr-2"
              >
                Proceed
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div v-if="toShow == 'selectTransfer'">
      <wire-transfer
        @goBack="showDeposit"
        @showAccountInfo="toShow = 'accountInformation'"
      />
    </div>
    <div v-if="toShow == 'accountInformation'">
      <account-information
        @goBack="showTransferType"
        @completedDeposit="toShowPendingDeposit"
      />
    </div>
  </el-dialog>
</template>

<script>
import { FormatAmount, AddComma } from '@/utils/helpers'
import breakpoints from '@/utils/breakpoints.js'

export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    toShowTransferType: {
      type: String,
      default: 'depositAmount'
    }
  },
  data () {
    return {
      breakpoints,
      toShow: this.toShowTransferType,
      isLoading: false,
      depositAmountForm: {
        amount: ''
      },
      rules: {
        amount: [
          {
            required: true,
            message: 'Amount is required'
          }
        ]
      }
    }
  },
  methods: {
    toShowPendingDeposit () {
      this.$emit('closeDialog')
      this.$emit('completedDeposit')
    },
    showDeposit () {
      this.toShow = 'depositAmount'
    },
    showTransferType () {
      this.toShow = 'selectTransfer'
    },
    validateDepositAmount (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.initiateDepositAmount()
        } else {
          this.$notify.error({
            title: 'Invalid Amount',
            message: 'please input a valid amount',
            position: 'top-right'
          })
        }
      })
    },
    initiateDepositAmount () {
      const vm = this
      const amount = FormatAmount(this.depositAmountForm.amount)
      const currency = this.depositAmountForm.currency
      if (!this.isLoading) {
        this.isLoading = true
        this.$store
          .dispatch('transactions/initiateDeposit', { amount, currency })
          .then(() => {
            this.getTransactions()
            this.toShow = 'selectTransfer'
          })
          .catch((error) => {
            const err = error.response
              ? error.response.data.error.publicMessage
              : error
            vm.$message({
              showClose: true,
              message: this.httpErrorMessage,
              type: 'error'
            })
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    },
    getTransactions () {
      const vm = this
      const payload = {
        number: 1,
        size: 3,
        status: '',
        type: '',
        from: '',
        to: ''
      }
      this.$store
        .dispatch('transactions/getTransactions', payload)
        .then(() => {})
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.$message({
            showClose: true,
            message: this.httpErrorMessage,
            type: 'error'
          })
        })
    },
    handleClose () {
      this.$emit('closeDialog')
    }
  },
  components: {
    WireTransfer: () => import('@/components/deposit/WireTransfer.vue'),
    AccountInformation: () =>
      import('@/components/deposit/AccountInformation.vue')
  },
  computed: {
    pendingDepositDetails () {
      if (
        this.$store.state.transactions.transactions &&
        this.$store.state.transactions.transactions.items
      ) {
        const latestTransaction =
          this.$store.state.transactions.transactions.items
        if (latestTransaction.length > 0) {
          const pendingDeposit = latestTransaction.filter(
            (transaction) => transaction.status === this.$STATUS.PENDING
          )
          if (pendingDeposit.length > 0) {
            return pendingDeposit[0]
          }
        }
      }
      return null
    },
    modalWidth () {
      return breakpoints.lgAndUp ? '35%' : breakpoints.mdAndUp ? '70%' : '90%'
    }
  },
  mounted () {
    if (
      this.pendingDepositDetails !== null &&
      this.pendingDepositDetails.amount
    ) {
      this.depositAmountForm.amount = `$${this.pendingDepositDetails.amount}`
    }
  },
  watch: {
    'depositAmountForm.amount': function (newValue) {
      let result = newValue.replace(/\D/g, '')
      result = AddComma(result)
      result.replace(/^0+/g, '')
      this.$nextTick(() => {
        this.depositAmountForm.amount = ` $${result}`
      })
    },
    deep: true
  }
}
</script>

<style scoped>
>>> .el-input__inner {
  border-radius: 8px;
  letter-spacing: 5px;
  padding-right: 3px;
  text-align: center;
  line-height: 10px;
  font-weight: 700;
  font-size: 40px;
  border-color: #c7c8d2;
  height: 70px;
}

>>> .el-button.is-disabled {
  background-color: #f4a177;
  color: white;
}
>>> .el-dialog {
  border-radius: 30px;
  padding: 20px;
}
>>> .el-dialog__body {
  padding: 10px 20px;
}
>>> .el-dialog__wrapper {
  overflow: hidden;
  top: 14px;
}
>>> .el-icon-close:before {
  padding: 25px;
  color: #c1c4ca;
}
>>> .el-dialog__headerbtn :hover {
  color: #c1c4ca !important ;
}
</style>
